import { get } from '@/libs/http';
import type { RefreshRes } from '@/types/api/user-auth/refresh';
import { createApiMutationHook } from '@/hooks/use-api-mutation';

export const getRefresh = () => {
  return get<RefreshRes>('/user/auth/v1/refresh');
};

export const useRefreshMutation = createApiMutationHook(getRefresh);
